import { useState } from 'react'
import { AllocationTableHeader, Table } from 'components/time-entry-table'
import {
  EntriesGrid,
  TaskNameColumn,
  TaskTotalColumn,
} from '@features/time-logging/components'
import { EtcColumn } from '../entries-table/EtcColumn'
import { DateTime } from 'luxon'
import { useWeekScope } from '@hooks/useWeekScope'
import { taskSourceCode } from '@utils/taskSourceCode'

interface Props {
  taskIdsWithEntries: Set<number>
  focusedCell: Cell
  headerHoverHandler: HeaderHoverHandler
  onCellFocus: (cell: Cell) => void
  onCellSaveViaEnter: () => void
  project: Project
  projectIntegration?: ProjectIntegration
  readOnly: boolean
  rowStart: number
  show: 'etc' | 'totals'
  tasks: SelectedTask[]
  start: DateTime
  end: DateTime
}

function AllocationTable(props: Props) {
  const [hoverY, setHoverY] = useState(0)
  const [expanded, setExpanded] = useState(true)
  const { weekStartsOn } = useWeekScope()

  return (
    <div className="mt-2">
      <AllocationTableHeader
        expanded={expanded}
        onExpandChange={setExpanded}
        projectName={props.project.name}
        sourceCode={taskSourceCode(props.projectIntegration)}
      />
      {expanded && (
        <Table
          key={`project_table_${props.project.id}`}
          weekStartsOn={weekStartsOn}
        >
          <TaskNameColumn
            taskIdsWithEntries={props.taskIdsWithEntries}
            hoverY={hoverY}
            tasks={props.tasks}
            start={props.start}
            end={props.end}
          />
          <EntriesGrid
            project={props.project}
            tasks={props.tasks}
            headerHoverHandler={props.headerHoverHandler}
            yHoverHandler={setHoverY}
            focusedCell={props.focusedCell}
            rowStart={props.rowStart}
            onSaveViaEnter={props.onCellSaveViaEnter}
            onCellFocus={props.onCellFocus}
            readOnly={props.readOnly}
          />
          {props.show === 'totals' && <TaskTotalColumn tasks={props.tasks} />}
          {props.show === 'etc' && <EtcColumn tasks={props.tasks} />}
        </Table>
      )}
    </div>
  )
}

export default AllocationTable
